export const passwordPattern = (password: string, password_ck: string) => {
    const regExpPwKeyboardListCheck = /^(?!.*(qwe|wer|ert|rty|tyu|yui|uio|iop|asd|sdf|dfg|fgh|ghj|hjk|jkl|zxc|xcv|cvb|vbn|bnm)).*$/;
    const regExpPwSameCheck =
        /^(?!.*(qq|ww|ee|rr|tt|yy|uu|ii|oo|pp|aa|ss|dd|ff|gg|hh|jj|kk|ll|zz|xx|cc|vv|bb|nn|mm|11|22|33|44|55|66|77|88|99|00)).*$/;
    const regExpPwCheck = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,16}$/;

    if (!regExpPwSameCheck.test(password)) {
        return {
            code: 2,
            content: "*동일한 문자는 2자 이상 사용할 수 없습니다.",
        };
    } else if (!regExpPwKeyboardListCheck.test(password)) {
        return {
            code: 3,
            content: "*연속된 문자열은 3자 이상 사용할 수 없습니다.",
        };
    } else if (!regExpPwCheck.test(password)) {
        return {
            code: 4,
            content: "*비밀번호는 8~16자 이내 영문,숫자 조합 으로 사용해야 합니다.",
        };
    } else if (password !== "" && password === password_ck) {
        return {
            code: 0,
            content: "",
        };
    } else if (password !== password_ck) {
        return {
            code: 1,
            content: "*비밀번호가 불일치합니다.",
        };
    }
};
export const emailPattern = (email: string) => {
    const emailRegex = /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
    if (emailRegex.test(email)) {
        return {
            code: 0,
            content: "",
        };
    } else {
        return {
            code: 1,
            content: "이메일 형식을 확인해주세요",
        };
    }
};
